import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'
import { TransparentOverlay } from 'widgets/TransparentOverlay'

import image from 'assets/images/post-complete-mask.png'

import { FinalStepActionsProps } from '../types'

export const FinalStepActions = ({
  handleCompletePost,
  handleRepeatPost,
  handleBack,
  isLoading,
  isCompleted,
  isWorkout,
  isLastSection,
}: FinalStepActionsProps) => {
  if (!isLastSection) {
    return null
  }

  return (
    <Box flex={1} backgroundColor='primary' margin={{ horizontal: 'lg' }}>
      <TransparentOverlay source={image}>
        <Box flex={1} justifyContent='center' align='center'>
          <Box testID='WayToGoContainer' margin={{ bottom: 'xs' }}>
            <Title color='white' size='lg' bold>
              WAY TO GO
            </Title>
          </Box>
          <Pressable disabled={isLoading || isCompleted} onPress={handleCompletePost}>
            <Box height={256} justifyContent='flex-end' align='center'>
              <Box testID='IconContainer'>
                <Icon name='post-complete-upswing' size={256} />
              </Box>
              <Box
                testID='CompletedText'
                padding={{ bottom: 'lg' }}
                margin={{ top: -64, bottom: 'lg' }}
              >
                <Text color='white' fontSize='sm' bold align='center' numberOfLines={1}>
                  {!isCompleted ? 'Tap to complete' : 'Completed!'}
                </Text>
              </Box>
            </Box>
          </Pressable>
        </Box>

        <Box flexDirection='row' margin={{ bottom: 'lg' }}>
          {isWorkout && (
            <Box flex={1} margin='xs'>
              <Pressable onPress={handleBack}>
                <Box
                  height={50}
                  borderRadius='sm'
                  border={{ width: 2, color: 'white' }}
                  justifyContent='center'
                  align='center'
                >
                  <Text color='white' fontSize='sm' bold>
                    BACK
                  </Text>
                </Box>
              </Pressable>
            </Box>
          )}
          {!isWorkout && (
            <Box flex={2} margin='sm' flexDirection='row' justifyContent='flex-start'>
              <Box flex={1} />
              <Box flex={2}>
                <Pressable onPress={handleBack}>
                  <Box
                    height={50}
                    borderRadius='sm'
                    border={{ width: 2, color: 'white' }}
                    justifyContent='center'
                    align='center'
                  >
                    <Text color='white' fontSize='sm' bold>
                      BACK
                    </Text>
                  </Box>
                </Pressable>
              </Box>
              <Box flex={1} />
            </Box>
          )}
          {isWorkout && (
            <Box flex={1} margin='xs'>
              <Pressable onPress={handleRepeatPost}>
                <Box
                  height={50}
                  borderRadius='sm'
                  border={{ width: 2, color: 'white' }}
                  justifyContent='center'
                  align='center'
                >
                  <Text color='white' fontSize='sm' bold>
                    REPEAT
                  </Text>
                </Box>
              </Pressable>
            </Box>
          )}
        </Box>
      </TransparentOverlay>
    </Box>
  )
}
